module.exports = __webpack_public_path__ + "media/img/avatars/teams/team-logo-5-1f8abd30ac26e0b88ad171324eb4b28e.jpg";